import React from 'react';
import { Menu, MenuItem, Divider, ListItemIcon, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { AccountCircleOutlined, SettingsOutlined, LogoutOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebaseConfig';

const ProfileMenu = ({ anchorEl, open, onClose }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    onClose(); // Close menu after navigation
  };

  const handleLogout = () => {
    auth.signOut()
      .then(() => navigate('/login'))
      .catch((error) => console.error('Error signing out:', error));

    onClose();
  };

  return (
    <Menu
      id="profile-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        mt: 1,
        '& .MuiPaper-root': {
          borderRadius: '12px',
          boxShadow: (theme) => theme.palette.mode === 'dark' ? '0 10px 28px rgba(0,0,0,0.45)' : '0 8px 24px rgba(0,0,0,0.10)',
          border: (theme) => `1px solid ${theme.palette.divider}`,
          backgroundColor: (theme) => theme.palette.background.paper,
          minWidth: 220,
          padding: '8px 0',
        },
      }}
    >
      {/* Profile */}
      <MenuItem onClick={() => handleNavigate('/profile')} aria-label="Go to profile" sx={menuItemStyle}>
        <ListItemIcon>
          <AccountCircleOutlined sx={{ color: (theme) => theme.palette.primary.main }} />
        </ListItemIcon>
        <Typography variant="body2" sx={{ color: (theme) => theme.palette.text.primary, fontWeight: 500 }}>Profile</Typography>
      </MenuItem>

      {/* Settings */}
      <MenuItem onClick={() => handleNavigate('/settings')} aria-label="Open settings" sx={menuItemStyle}>
        <ListItemIcon>
          <SettingsOutlined sx={{ color: (theme) => theme.palette.primary.main }} />
        </ListItemIcon>
        <Typography variant="body2" sx={{ color: (theme) => theme.palette.text.primary, fontWeight: 500 }}>Settings</Typography>
      </MenuItem>

      <Divider sx={{ my: 1 }} />

      {/* Logout */}
      <MenuItem onClick={handleLogout} aria-label="Sign out" sx={{ 
        ...menuItemStyle, 
        color: '#D32F2F',
        '&:hover': { backgroundColor: 'rgba(211,47,47,0.10)' },
        '&:focus-visible': { outline: '2px solid rgba(211,47,47,0.5)', outlineOffset: 2, borderRadius: '8px' }
      }}>
        <ListItemIcon>
          <LogoutOutlined sx={{ color: '#D32F2F' }} />
        </ListItemIcon>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>Logout</Typography>
      </MenuItem>
    </Menu>
  );
};

const menuItemStyle = {
  padding: '10px 16px',
  mx: 1,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
  },
  '&:focus-visible': { outline: (theme) => `2px solid ${alpha(theme.palette.primary.main, 0.6)}`, outlineOffset: 2, borderRadius: '8px' },
};

export default ProfileMenu;
